/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnumValue } from "./EnumValue";
export const CategoryMapping = core.serialization.object({
    sourceValue: EnumValue.optional(),
    destinationValue: EnumValue.optional(),
});
